(()=>{
  const ROOT_SELECTOR='.easygames-product-ficha-premium-v2-host .egf[data-egf-section-id]';
  const KNOWN_CATEGORIES=['juegos','digital','accesorios','funko','figura','amiibo','peliculas'];

  const parseConfig=(root)=>{
    const node=root.querySelector('[data-egf-runtime-config]');
    if(!node)return{};
    try{return JSON.parse(node.textContent||'{}');}catch(_){return{};}
  };

  const normalize=(value)=>String(value||'')
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g,'')
    .toLowerCase()
    .replace(/[^a-z0-9]+/g,' ')
    .trim();

  const clamp=(value,min,max,fallback)=>{
    const number=Number.parseInt(value,10);
    return Number.isFinite(number)?Math.max(min,Math.min(max,number)):fallback;
  };

  const boot=(root)=>{
    if(!root)return;
    const key=`__EasyGamesFichaV2_${root.dataset.egfSectionId||'default'}`;
    window[key]?.destroy?.();

    const cfg=parseConfig(root);
    const state={frame:0,media:null,onMedia:null,onSection:null,destroy:null,fansAbort:null,fansSignature:'',fansRun:0,fansObserver:null,fansReady:false};
    // EG Ficha: tablet (750–989) comparte apertura inicial con desktop; mobile conserva sus estados configurados.
    const accordionMedia=window.matchMedia('(min-width:750px)');

    const syncAccordions=()=>{
      const desktop=accordionMedia.matches;
      root.querySelectorAll('details.egf-accordion').forEach((details)=>{
        if(desktop&&cfg.desktopExpandAccordions!==false){
          details.setAttribute('data-eg-desktop-forced','true');
          details.open=true;
          return;
        }
        if(details.hasAttribute('data-eg-desktop-forced')){
          details.removeAttribute('data-eg-desktop-forced');
          if(cfg.mobileAccordions!==false)details.open=String(details.dataset.mobileOpen)==='true';
        }
      });
    };

    const syncReviewVisibility=()=>{
      if(cfg.reviewsAllowed!==false)return;
      root.querySelectorAll('.egf-review,.egf-review-verdict-card').forEach((element)=>{element.hidden=true;});
      root.querySelectorAll('.egf-review').forEach((review)=>{
        const previous=review.previousElementSibling;
        if(previous?.classList.contains('egf-kicker'))previous.hidden=true;
      });
    };

    const fillReviewBars=()=>{
      root.querySelectorAll('.egf-bar').forEach((bar)=>{
        const value=parseFloat(String(bar.querySelector('b')?.textContent||'').replace(',','.'));
        if(!Number.isFinite(value))return;
        const percent=Math.max(0,Math.min(100,value*20));
        const fill=bar.querySelector('.egf-fill');
        if(fill){
          fill.style.setProperty('--egf-fill',`${percent}%`);
          fill.style.setProperty('width',`${percent}%`,'important');
        }
      });
    };

    const readTags=(element)=>{
      if(!element)return[];
      const raw=element.getAttribute('data-tags')||element.querySelector('.egt-card')?.getAttribute('data-eg-tags')||'[]';
      try{
        const tags=JSON.parse(raw);
        return Array.isArray(tags)?tags.map(normalize).filter(Boolean):[];
      }catch(_){
        return[];
      }
    };

    const removeFansResults=()=>{
      root.querySelectorAll('.egf-fans-results[data-egf-owned="true"]').forEach((node)=>node.remove());
    };

    const syncFans=async()=>{
      const fans=root.querySelector('.egf-fans');
      if(!fans){
        state.fansAbort?.abort();
        state.fansAbort=null;
        state.fansSignature='';
        removeFansResults();
        return;
      }

      const terms=[...fans.querySelectorAll('.egf-pill')]
        .map((pill)=>String(pill.textContent||'').trim())
        .filter(Boolean);
      if(!terms.length)return;

      const productId=String(cfg.productId||'');
      const productTags=Array.isArray(cfg.productTags)?cfg.productTags.map(normalize).filter(Boolean):[];
      const currentCategory=KNOWN_CATEGORIES.find((tag)=>productTags.includes(tag))||'';
      const requiredTag=cfg.fansRequireTag===true?normalize(cfg.fansRequiredTag):'';
      const total=clamp(cfg.fansTotal,1,12,8);
      const visible=clamp(cfg.fansVisible,2,4,4);
      const signature=JSON.stringify({productId,terms,currentCategory,requiredTag,total,visible,heading:cfg.fansHeading,more:cfg.fansShowMore,moreLabel:cfg.fansMoreLabel,moreLink:cfg.fansMoreLink});

      if(signature===state.fansSignature&&root.querySelector('.egf-fans-results[data-egf-owned="true"]'))return;
      state.fansSignature=signature;
      state.fansAbort?.abort();
      const controller=new AbortController();
      state.fansAbort=controller;
      const run=++state.fansRun;
      removeFansResults();

      const collected=[];
      const seen=new Set(productId?[productId]:[]);
      const shopRoot=(window.Shopify?.routes?.root||'/').replace(/\/?$/,'/');

      try{
        for(const term of terms){
          if(collected.length>=total||controller.signal.aborted)break;
          const params=new URLSearchParams({
            q:term,
            'resources[type]':'product',
            'resources[limit]':'10',
            'resources[options][unavailable_products]':'hide',
            'resources[options][fields]':'title',
            section_id:'easygames-fans-search'
          });
          const response=await fetch(`${shopRoot}search/suggest?${params.toString()}`,{
            credentials:'same-origin',
            headers:{Accept:'text/html'},
            signal:controller.signal
          });
          if(!response.ok)continue;
          const html=await response.text();
          if(controller.signal.aborted||run!==state.fansRun)return;
          const doc=new DOMParser().parseFromString(html,'text/html');

          for(const item of doc.querySelectorAll('.egf-fan-search-item')){
            if(collected.length>=total)break;
            const card=item.querySelector('.egt-card');
            if(!card)continue;
            const candidateId=String(card.dataset.productId||'');
            if(!candidateId||seen.has(candidateId))continue;

            const tags=readTags(item);
            if(currentCategory&&!tags.includes(currentCategory))continue;
            if(requiredTag&&!tags.includes(requiredTag))continue;

            seen.add(candidateId);
            collected.push(card.cloneNode(true));
          }
        }
      }catch(error){
        if(error?.name!=='AbortError')console.warn('[EASY GAMES] Ideal para fans: no se pudieron cargar productos similares.',error);
      }

      if(controller.signal.aborted||run!==state.fansRun)return;
      state.fansAbort=null;
      if(!collected.length)return;

      const sourceCard=fans.closest('.egf-card');
      if(!sourceCard?.parentNode)return;

      const section=document.createElement('section');
      section.className='egf-fans-results';
      section.dataset.egfOwned='true';
      section.setAttribute('aria-label',String(cfg.fansHeading||'También te puede interesar'));

      const header=document.createElement('div');
      header.className='egf-fans-results__header';
      const heading=document.createElement('h3');
      heading.className='egf-fans-results__heading';
      heading.textContent=String(cfg.fansHeading||'También te puede interesar');
      header.appendChild(heading);

      if(cfg.fansShowMore!==false){
        const more=document.createElement('a');
        more.className='egf-fans-more';
        more.textContent=String(cfg.fansMoreLabel||'Ver más');
        const configured=String(cfg.fansMoreLink||'').trim();
        more.href=configured||`${shopRoot}search?q=${encodeURIComponent(terms[0])}&type=product`;
        header.appendChild(more);
      }

      const products=document.createElement('div');
      products.className='egf-fans-products';
      products.dataset.visible=String(visible);
      products.setAttribute('role','list');
      collected.forEach((card)=>{
        card.setAttribute('role','listitem');
        products.appendChild(card);
      });

      section.append(header,products);
      sourceCard.insertAdjacentElement('afterend',section);
    };

    const armFans=()=>{
      const fans=root.querySelector('.egf-fans');
      if(!fans){
        state.fansObserver?.disconnect();
        state.fansObserver=null;
        state.fansReady=false;
        state.fansAbort?.abort();
        state.fansAbort=null;
        state.fansSignature='';
        removeFansResults();
        return;
      }

      if(state.fansReady){
        void syncFans();
        return;
      }
      if(state.fansObserver)return;

      if(typeof IntersectionObserver!=='function'){
        state.fansReady=true;
        void syncFans();
        return;
      }

      state.fansObserver=new IntersectionObserver((entries)=>{
        if(!entries.some((entry)=>entry.isIntersecting))return;
        state.fansReady=true;
        state.fansObserver?.disconnect();
        state.fansObserver=null;
        void syncFans();
      },{rootMargin:'700px 0px'});
      state.fansObserver.observe(fans);
    };

    const sync=()=>{
      state.frame=0;
      syncAccordions();
      syncReviewVisibility();
      fillReviewBars();
      armFans();
    };
    const schedule=()=>{if(!state.frame)state.frame=requestAnimationFrame(sync);};

    state.onMedia=schedule;
    state.onSection=(event)=>{
      if(event.target?.contains?.(root)||event.target===root)schedule();
    };
    state.media=accordionMedia;
    accordionMedia.addEventListener?.('change',state.onMedia);
    document.addEventListener('shopify:section:load',state.onSection);

    state.destroy=()=>{
      if(state.frame)cancelAnimationFrame(state.frame);
      state.fansAbort?.abort();
      state.fansObserver?.disconnect();
      removeFansResults();
      state.media?.removeEventListener?.('change',state.onMedia);
      document.removeEventListener('shopify:section:load',state.onSection);
    };

    window[key]=state;
    schedule();
  };

  const init=(scope=document)=>{
    if(scope.matches?.(ROOT_SELECTOR))boot(scope);
    scope.querySelectorAll?.(ROOT_SELECTOR).forEach(boot);
  };

  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',()=>init(),{once:true});
  else init();
})();
